// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"9a04bcbdc365a662ffc4","339":"3e5549e66b78cebab52b"}[chunkId] + ".js";
};